// extracted by mini-css-extract-plugin
module.exports = {"container":"Veto_container__2qHBg","title":"Veto_title__HbChY","description":"Veto_description__u4KFQ"};